import React, { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';

import ModuleApi from '../../../../Logicas/ModuleApi';
import IconRemove from '../../../utils/img/ic-excluir.svg';
import IconDrag from '../../../utils/img/more-vertical.svg';
import IconArrow from '../../../utils/img/chevron-down.svg';

import './CourseLongStyles.css';
import { reduxForm } from 'redux-form';

class ListModules extends Component {
  constructor() {
    super();
    this.removedModule = this.removedModule.bind(this);
    this.moveModulesAndSubmodules = this.moveModulesAndSubmodules.bind(this);
    this.moveSubmodulesContents = this.moveSubmodulesContents.bind(this);
  }

  componentDidMount() {
    this.setState({ modulesCourse: this.props.listModulesCourse || [] });
  }

  componentDidUpdate(prevProps, prevState) {
    const prevListModulesCourse = prevProps.listModulesCourse || [];
    const listModulesCourse = this.props.listModulesCourse || [];

    const hasUpdateInModuleOrSubmodule =
      prevListModulesCourse.length !== listModulesCourse.length ||
      listModulesCourse.some(
        (module, mIndex) =>
          module.id !== prevListModulesCourse[mIndex].id ||
          module.submodules.length !==
            prevListModulesCourse[mIndex].submodules.length ||
          module.submodules.some(
            (submodule, sIndex) =>
              submodule.id !==
              prevListModulesCourse[mIndex].submodules[sIndex].id
          )
      );
    if (hasUpdateInModuleOrSubmodule)
      this.setState({ modulesCourse: listModulesCourse });

    const hasNewModuleToMap = !listModulesCourse.every(
      (item) => item.id in this.state.moduleOpenMap
    );
    if (!hasNewModuleToMap) return;

    const moduleOpenMap = Object.fromEntries(
      listModulesCourse.map((item) => [item.id, true])
    );
    this.setState({
      moduleOpenMap: { ...moduleOpenMap, ...prevState.moduleOpenMap }
    });
  }

  toggleModuleSubmodules(moduleId) {
    const newModuleOpenMap = { ...this.state.moduleOpenMap };
    newModuleOpenMap[moduleId] = !newModuleOpenMap[moduleId];
    this.setState({ moduleOpenMap: newModuleOpenMap });
  }

  removedModule(idModule, idCourse) {
    if (this.props.listModulesCourse.length > 1) {
      this.props.deleteModule(idModule, idCourse);
    }
  }

  moveModulesAndSubmodules(courseId, modules_course_position) {
    this.props.moveModulesAndSubmodules(courseId, modules_course_position);
  }

  moveSubmodulesContents() {
    this.props.moveSubmodulesContents();
  }

  state = {
    modulesCourse: [],
    moduleOpenMap: {}
  };

  arrayMove = (array, fromIndex, toIndex) =>
    array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);

  buildPayload = (modulesOrSubmodules) => ({
    modules_course_position: modulesOrSubmodules.map(({ id }, index) => ({
      module_course_id: id,
      queue: index
    }))
  });

  moveModule = ({ source, destination }) => {
    const modulesCourse = this.state.modulesCourse.slice();
    this.arrayMove(modulesCourse, source.index, destination.index);
    this.setState({ modulesCourse });

    const courseId = modulesCourse[0] && modulesCourse[0].course_id;
    this.moveModulesAndSubmodules(courseId, this.buildPayload(modulesCourse));
  };

  moveSubmodule = ({ source, destination }) => {
    const modulesCourse = this.state.modulesCourse.slice();
    const targetModule = modulesCourse.find(
      (module) => `${module.id}` === source.droppableId
    );

    this.arrayMove(
      targetModule.submodules || [],
      source.index,
      destination.index
    );

    this.setState({ modulesCourse });

    const courseId = modulesCourse[0] && modulesCourse[0].course_id;

    this.moveModulesAndSubmodules(
      courseId,
      this.buildPayload(targetModule.submodules)
    );
  };

  callbackByType = {
    module: this.moveModule,
    submodule: this.moveSubmodule
  };

  onDragEnd = (result) => {
    const { source, destination, type } = result;

    if (
      !destination ||
      (source.droppableId === destination.droppableId &&
        source.index === destination.index)
    )
      return;

    const cleanType = (type || '').split('@')[0];
    const callback = this.callbackByType[cleanType];

    callback && callback(result);
  };

  findSubmoduleInterval = 0;
  aElement = document.createElement('a');

  scrollToSubmodule(submoduleId) {
    clearInterval(this.findSubmoduleInterval);

    const submoduleInterval = setInterval(() => {
      const target = document.querySelector(`#title-submodule-${submoduleId}`);

      if (!target) return;

      this.aElement.href = `#title-submodule-${submoduleId}`;
      this.aElement.click();
      clearInterval(submoduleInterval);
    }, 300);

    this.findSubmoduleInterval = submoduleInterval;
  }

  render() {
    return (
      <div className="container-list-modules">
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId={'list-modules-droppable'} type="module">
            {(moduleDroppable) => (
              <div
                className="list-modules"
                ref={moduleDroppable.innerRef}
                {...moduleDroppable.droppableProps}
              >
                {this.state.modulesCourse.map((module, index) => (
                  <Draggable
                    draggableId={`${module.id}@${index}`}
                    key={`${module.id}@${index}`}
                    index={index}
                  >
                    {(moduleDraggable) => (
                      <div
                        className="module-wrapper"
                        ref={moduleDraggable.innerRef}
                        {...moduleDraggable.draggableProps}
                      >
                        <div
                          className={`card-module ${this.props.moduleActive ===
                            index && 'card-select'}`}
                          onClick={() => this.props.sendSelectModule(index)}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px'
                            }}
                          >
                            <img
                              src={IconDrag}
                              alt="Mover módulo"
                              onClick={(event) => event.stopPropagation()}
                              {...moduleDraggable.dragHandleProps}
                            />

                            <div>
                              <p className="card-title-module">
                                {index + 1}.{' '}
                                {module.name && module.name.length > 30
                                  ? `${module.name.slice(0, 30)}...`
                                  : module.name}
                              </p>
                              <p className="card-description-module">
                                {module.description &&
                                module.description.length > 38
                                  ? `${module.description.slice(0, 38)}...`
                                  : module.description}
                              </p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '30px'
                            }}
                          >
                            <img
                              className={`dropdown-image ${
                                !this.state.moduleOpenMap[module.id]
                                  ? 'open'
                                  : 'closed'
                              }`}
                              src={IconArrow}
                              alt="Mostrar/Esconder submódulos"
                              onClick={(event) => {
                                event.stopPropagation();
                                this.toggleModuleSubmodules(module.id);
                              }}
                            />

                            <div className="remove-module">
                              <img
                                src={IconRemove}
                                alt="Remover módulo"
                                onClick={() =>
                                  this.removedModule(
                                    module.id,
                                    module.course_id
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>

                        {!!module.submodules.length &&
                          this.state.moduleOpenMap[module.id] && (
                            <Droppable
                              droppableId={`${module.id}`}
                              type={`submodule@${index}`}
                            >
                              {(submoduleDroppable) => (
                                <div
                                  className="list-submodules"
                                  ref={submoduleDroppable.innerRef}
                                  {...submoduleDroppable.droppableProps}
                                >
                                  {module.submodules.map((subm, submIndex) => (
                                    <Draggable
                                      draggableId={`${subm.id}@${submIndex}`}
                                      key={`${subm.id}@${submIndex}`}
                                      index={submIndex}
                                    >
                                      {(submoduleDraggable) => (
                                        <div
                                          className={`card-submodule ${this
                                            .props.moduleActive === index &&
                                            this.props.submoduleActive ===
                                              submIndex &&
                                            'card-select'}`}
                                          ref={submoduleDraggable.innerRef}
                                          {...submoduleDraggable.draggableProps}
                                          onClick={() => {
                                            this.props.sendSelectModule(index);
                                            this.props.sendSelectSubmodule(
                                              submIndex
                                            );
                                            this.scrollToSubmodule(subm.id);
                                          }}
                                        >
                                          <img
                                            src={IconDrag}
                                            {...submoduleDraggable.dragHandleProps}
                                          />
                                          <p className="card-title-submodule">
                                            {subm.name}
                                          </p>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}

                                  {submoduleDroppable.placeholder}
                                </div>
                              )}
                            </Droppable>
                          )}
                      </div>
                    )}
                  </Draggable>
                ))}

                {moduleDroppable.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <div
          className="new-module-btn"
          onClick={() =>
            this.props.createModule(
              this.props.idCourseModules,
              this.props.listModulesCourse.length
            )
          }
        >
          <p>
            <strong>+</strong>
          </p>
          <p>NOVO MÓDULO</p>
        </div>
      </div>
    );
  }
}

let ListModulesContainer = reduxForm({
  form: 'listmodules'
})(ListModules);

const mapDispatchToProps = (dispatch) => {
  return {
    sendSelectModule: (moduleActive) => {
      dispatch({
        type: 'SELECT_MODULE',
        moduleActive: moduleActive
      });
    },
    sendSelectSubmodule: (submoduleActive) => {
      dispatch({
        type: 'SELECT_SUBMODULE',
        submoduleActive: submoduleActive
      });
    },
    createModule: (courseid, module_size, typeCourse) => {
      dispatch(
        ModuleApi.createModule(
          {
            module_title: `Módulo ${module_size + 1}`,
            module_score: 0,
            module_description: `Descrição Modulo ${module_size + 1}`,
            idcourse: courseid
          },
          courseid
        )
      );
    },
    deleteModule: (idModule, idCourse) => {
      dispatch(ModuleApi.deleteModule(idModule, idCourse, 'long'));
    },
    moveModulesAndSubmodules: (courseId, modules_course_position) => {
      dispatch(
        ModuleApi.moveModulesAndSubmodules(courseId, modules_course_position)
      );
    }
  };
};

ListModulesContainer = connect(
  (state, props) => ({
    loading: state.progress_indeterminate,
    submoduleActive: state.course.submoduleActive
  }),
  mapDispatchToProps
)(ListModulesContainer);

export default ListModulesContainer;
